/**
 * LanguageSync
 * Sincroniza el idioma activo de i18next y el atributo `lang` del <html> con
 * el prefijo de la URL, que es la única fuente de verdad del idioma. No
 * renderiza nada; debe montarse dentro del Router.
 */

import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getLanguageFromPath } from './paths';

/**
 * @returns {null} Componente sin salida visual
 */
const LanguageSync = () => {
  const { pathname } = useLocation();
  const { i18n } = useTranslation();
  const language = getLanguageFromPath(pathname);

  // useLayoutEffect: el idioma se aplica antes de pintar para evitar un
  // parpadeo con el texto del idioma anterior.
  useLayoutEffect(() => {
    if (i18n.language !== language) {
      i18n.changeLanguage(language);
    }
    document.documentElement.lang = language;
  }, [language, i18n]);

  return null;
};

export default LanguageSync;
